import { render, staticRenderFns } from "./SpeakersContentBlock.vue?vue&type=template&id=586f6adb"
import script from "./SpeakersContentBlock.vue?vue&type=script&lang=ts"
export * from "./SpeakersContentBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports